// id should be string

export function scrolltoView(id) {
  if (id) {
    setTimeout(() => {
      document.querySelector(id)?.scrollIntoView({
        block: "center",
        behavior: "smooth",
        inline: "start",
      });
    }, 500);
  }
}
export function updateClassScroll(id) {
  if (id) {
    setTimeout(() => {
      document.querySelector(id)?.scrollIntoView({
        block: "start",
        behavior: "smooth",
        inline: "start",
      });
    }, 500);
  }
}

export function srcollIntoStudent(id) {
  if (id) {
    const doc = document.getElementById(id);

    const mainLayout = document.getElementById("mainLayout");

    mainLayout.scrollTo({
      x: 0,
      y: doc?.getBoundingClientRect().top,
      behavior: "smooth",
    });
  }
}
